import { useState, useEffect } from "react";
import axios from "axios";
import { useMsal } from "@azure/msal-react";

import "./Analytics.css";

function Analytics() {
  const [data, setData] = useState([]);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  //const baseURL = "http://localhost:1501";
  const baseURL = "https://atci.lkm.foreignlanguage.accenture.com/foreign-apis";

  const lkmPagesAnalytics = () => {
    axios
      .post(`${baseURL}/analytics`, {
        enterprise_id: loggedInEnterpriseId,
      },
    {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        })
      .then((response) => {
        getAnalytics();
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAnalytics = () => {
    axios
      .get(`${baseURL}/analytics`,
        {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
      )
      .then((response) => {
        setData(response.data);
        console.log("res", response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const totalUserViews = data.map((view) => view.totalUniqueUsers);
  const totalViews =
    Array.isArray(data) &&
    data.reduce((acc, view) => {
      const sumOfViews = view.Data.reduce(
        (sum, userView) => sum + Number(userView.total_views),
        0
      );
      return acc + sumOfViews;
    }, 0);
  console.log("totalViews", totalViews, "totalUserViews", totalUserViews);
  useEffect(() => {
    if (process.env.NODE_ENV === "production" && loggedInEnterpriseId !== "")
      lkmPagesAnalytics();
  }, []);

  return (
    <>
      {process.env.NODE_ENV === "production" && (
        <span className="analytics-span">
          <img
            src="images/Home/medium-eye.png"
            className="eye-icon"
            alt="eye"
          />
          Total Views: {totalViews} &nbsp; | &nbsp; Unique Views:{" "}
          {totalUserViews}
        </span>
      )}{" "}
    </>
  );
}

export default Analytics;
